import doctor_1 from './doctor_1.jpg';
import doctor_2 from './doctor_2.jpg';
import doctor_3 from './doctor_3.jpg';
import doctor_4 from './doctor_4.jpg';
import doctor_5 from './doctor_5.jpg';
import doctor_6 from './doctor_6.jpg';
import doctor_7 from './doctor_7.jpg';
import doctor_8 from './doctor_8.jpg';
import doctor_9 from './doctor_9.jpg';
import doctor_10 from './doctor_10.jpg';
import doctor_11 from './doctor_11.jpg';
import doctor_12 from './doctor_12.jpg';
import klinika from './klinika.png';

export default [
    undefined, doctor_1, doctor_2, doctor_3, doctor_4, doctor_5, doctor_6, doctor_7, doctor_8, doctor_9,
    doctor_10, doctor_11, doctor_12, klinika
]


// WEBPACK FOOTER //
// ./src/assets/img/llc/doctors/index.js